import { cva, type VariantProps } from "class-variance-authority";

export { default as Card } from "./Card.vue";

export const cardVariants = cva(
  "rounded-xl bg-white shadow-xl",
  {
    variants: {
      variant: {
        default: "p-6",
        landing:
          "pt-[106px] pr-[180px] pb-[128px] pl-[180px] max-[1199px]:py-[72px] max-[1199px]:px-[26px]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export type CardVariants = VariantProps<typeof cardVariants>;
